<script lang="ts">
    import {SqrlGlobal} from "../../util/SqrlGlobal";
    import {tracking} from "../../tracking/Tracking";
    import {SanHeader} from "../../events/sanHeader";
    import {SQRL_EVENT} from "../../events/sqrlEvents";
    import {submitStore} from "../../store/SubmitStore";
    import {FindClass} from "../../constants/squirrel";

    const findHeader = (): HTMLDivElement => document.querySelector(".reptile_header") as HTMLDivElement || document.querySelector(`.${FindClass.HEADER}`) as HTMLDivElement
    const searchField = (): HTMLInputElement => document.querySelector(".js_squirrel_searchbar__input") as HTMLInputElement;

    function isVisible(parent: HTMLElement): boolean {
        return parent.classList.contains(FindClass.HEADER_VISIBILITY) || parent.classList.contains("reptile_header--visibleSearchbar") || false;
    }

    function toggle(force?: boolean) {
        const findHeaderElement = findHeader();
        const wasVisible = isVisible(findHeaderElement);

        findHeaderElement.classList.toggle("reptile_header--visibleSearchbar", force);
        const san_Header = wasVisible ? SanHeader.CLOSE : SanHeader.OPEN;
        if (!wasVisible) {
            searchField()?.focus();
            SqrlGlobal.scrollTo(searchField());
        }
        tracking.trackSubmitEvent({san_Header: [san_Header]});
    }

    function toggleSearchField(event: Event) {
        if (event instanceof KeyboardEvent && event.key !== "Enter") return;
        toggle();
    }

    window.o_global.events().on(SQRL_EVENT.SEARCH_HIDE, () => toggle(false));
    window.o_global.events().on(SQRL_EVENT.SEARCH_SHOW, (context) => {
        submitStore.$breadcrumbSearch = context?.breadcrumb || false;
        toggle(true);
    });
</script>

<ofc-header-icon-v1
    icon="search"
    text="Suche"
    onclick={toggleSearchField}
    onkeydown={toggleSearchField}
></ofc-header-icon-v1>